import script from "./billing.vue?vue&type=script&setup=true&lang=js"
export * from "./billing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__